import { faAddressCard, faAward, faBoxesStacked, faChartBar, faChartColumn, faChartLine, faCog, faCreditCard, faFileAlt, faFileInvoice, faFileInvoiceDollar, faPowerOff, faShoppingCart, faTruckFast, faWarehouse } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Tooltip } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import logo from '../../images/logo2.png'
import './Sidebar.scss'
import { ReactComponent as Plan } from './plan.svg'
import { ReactComponent as Matel } from './matel.svg'

import { getClockNumberUtilityClass } from '@mui/x-date-pickers/TimeClock/clockNumberClasses'
import { getMode } from '../../utils/app.utils'
// import { AUTH_CONFIG } from '../../auth/config'
export default function Sidebar() {
    const { profile } = useSelector(state => state.profile)
    const { noti, loading } = useSelector(state => state.noti)
    const mode = getMode()
    const pathName = [
        {
            path: '/',
            name: 'dashboard',
            icon: <FontAwesomeIcon icon={faChartColumn} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'สรุปข้อมูล').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/plan',
            name: 'แผนการผลิต',
            icon: <Box className='svgIcon'>
                <Plan />
            </Box>,
            // icon: <FontAwesomeIcon icon={faFileAlt} className='menu-icon' />,
            Permissions: mode === 'online' ? profile?.Permissions?.filter((x) => x?.Subject === 'แผนการผลิต').filter((y) => y.Permit === true).length > 0 : false
        },
        {
            path: '/raw',
            name: 'เมล็ดดิบ',
            icon: <Box className='svgIcon'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.5 47.5" id="sheafofrice"><defs><clipPath id="a"><path d="M0 38h38V0H0v38Z"></path></clipPath></defs><g clip-path="url(#a)" transform="matrix(1.25 0 0 -1.25 0 47.5)"><path fill="currentColor" d="M22.388 36.38c-1.853 0-4.235-1.849-6.22-4.826-2.322-3.483-1.069-5.988-.062-8.002A.998.998 0 0 1 17.8 23.4c2.395 3.192 6.211 8.196 6.907 8.893A.996.996 0 0 1 25 33c0 2.492-1.349 3.38-2.612 3.38M24.766 27.385c-1.21 0-2.575-1.132-4.565-3.785-2.124-2.832-2.462-5.314-1.095-8.048a1.001 1.001 0 0 1 1.663-.193c1.719 2.064 5.173 6.168 5.938 6.934A.997.997 0 0 1 27 23c0 1.084 0 4.385-2.234 4.385"></path><path fill="currentColor" d="M30.874 25.483a.998.998 0 0 1-1.359.385c-7.171-3.983-13.784-14.15-16.367-19.609.838 10.195 5.569 20.044 13.559 28.034a.999.999 0 1 1-1.414 1.414C17.33 27.744 12.466 17.99 11.288 7.826c-.674 5.698-.977 13.91 1.626 19.768a1 1 0 1 1-1.828.812c-1.325-2.983-1.945-6.501-2.161-10.008C8.04 20.282 7.001 22 5.472 22h-.046c-.91 0-1.691-.466-2.321-1.725-.247-.495-.046-.922.448-1.169a1 1 0 0 1 1.342.447c.311.622.524.769.521.792.636-.196 1.744-2.696 2.162-3.642.196-.443.374-.842.527-1.15a.987.987 0 0 1 .728-.529c.026-4.958.698-9.531 1.163-12.091l.02-.111a1 1 0 0 1 1.162-.806.97.97 0 0 1 .331.132A.972.972 0 0 1 12 2c.183 0 .344.063.492.148A.94.94 0 0 1 12.974 2h.025c.531 0 .972.448 1.001.981.057 1.037 2.494 6.013 6.143 11.043a.941.941 0 0 1 .304.082c.244.122.517.272.808.432.933.517 2.494 1.38 3.106 1.02.15-.088.639-.534.639-2.558a1 1 0 1 1 2 0c0 2.236-.53 3.636-1.622 4.28-.783.461-1.668.424-2.54.174 2.32 2.715 4.938 5.165 7.647 6.671a.996.996 0 0 1 .389 1.358"></path></g></svg>
            </Box>,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'เมล็ดพันธุ์ดิบ').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/stock',
            name: 'คงคลัง',
            icon: <FontAwesomeIcon icon={faWarehouse} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'คลังเมล็ดพันธุ์').filter((y) => y.Permit === true).length > 0
        },

        {
            path: '/sale',
            name: 'ขาย',
            icon: <FontAwesomeIcon icon={faShoppingCart} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'ขายเมล็ดพันธุ์').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/receipt',
            name: 'ใบเสร็จรับเงิน',
            icon: <FontAwesomeIcon icon={faFileInvoiceDollar} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'ใบเสร็จรับเงิน').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/transport',
            name: 'transport',
            icon: faTruckFast,
            Permissions: false
        },


        {
            path: '/agent',
            name: 'ข้อมูลลูกค้า',
            icon: <FontAwesomeIcon icon={faAddressCard} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'ลูกค้าและตัวแทนจำหน่าย').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/materials',
            name: 'วัสดุการผลิด',
            icon: <Box className='svgIcon'>
                <Matel />
            </Box>,
            // icon: <FontAwesomeIcon icon={faBoxesStacked} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'วัสดุการผลิต').filter((y) => y.Permit === true).length > 0
        },
        {
            path: '/report',
            name: 'รายงาน',
            icon: <FontAwesomeIcon icon={faChartLine} className='menu-icon' />,
            Permissions: mode === 'online' ? profile?.Permissions?.filter((x) => x?.Subject === 'รายงาน').filter((y) => y.Permit === true).length > 0 : false
        },
        {
            path: '/setting',
            name: 'ตั้งค่า',
            icon: <FontAwesomeIcon icon={faCog} className='menu-icon' />,
            Permissions: profile?.Permissions?.filter((x) => x?.Subject === 'การตั้งค่า').filter((y) => y.Permit === true).length > 0
        },
    ]
    const logOut = async () => {
        // const res = await api.get(AUTH_CONFIG.requests.logout.url)
        // const data = res.data
        // if (data.status === true) {
        localStorage.clear('accessTR')
        localStorage.clear('refreshTR')
        window.location.href = '/login'
        // }
    }

    return (
        <div className='sidebar' style={{ height: "100vh", display: 'flex', flexDirection: 'column', justifyContent: "space-between"}}>
            <div className="d-flex justify-content-center logo-row">
                <div className="navbar-brand text-center" >
                    <img src={logo} className="logo" alt="" />
                </div>
            </div>
            <nav className="bd-links text-center" id="bd-docs-nav" style={{maxHeight:"610px", overflow:'auto', margin:'20px 0px'}}>
                {pathName.filter((y) => y.Permissions === true).map((x, i) => (
                    <div key={i} className="bd-toc-item" >
                        <Tooltip title={x.name}>
                            <NavLink to={x.path} style={{ position: 'relative' }}>
                                <span className="bd-toc-link parent">
                                    {x.icon}
                                </span>
                                {x.name === 'คงคลัง' && (+noti?.NewReserveCenter + +noti?.NewTransferIn) > 0 ? <div style={{
                                    width: '22px',
                                    height: '22px',
                                    position: 'absolute',
                                    top: '-10px',
                                    right: '9px',
                                    background: 'red',
                                    color: '#fff',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}> {noti ? (+noti?.NewReserveCenter + +noti?.NewTransferIn) : 0}</div> : x.name === 'ข้อมูลลูกค้า' && (+noti?.NewAgentRequest) > 0 ? <div style={{
                                    width: '22px',
                                    height: '22px',
                                    position: 'absolute',
                                    top: '-10px',
                                    right: '9px',
                                    background: 'red',
                                    color: '#fff',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}> {noti ? (+noti?.NewAgentRequest) : 0}</div> : null}
                            </NavLink>
                        </Tooltip>
                    </div>
                ))}

            </nav>

            <nav className="bd-links text-center" onClick={logOut} id="bd-docs-nav">
                <div className="bd-toc-item">
                    <Tooltip title='ออกจากระบบ'>
                        <span className="bd-toc-link parent">
                            <FontAwesomeIcon icon={faPowerOff} className='menu-icon' />
                        </span>
                    </Tooltip>
                </div >
            </nav >
        </div>
    )
}
